import React__default from 'react';
import classnames from 'classnames';
import { SelectionBoxRadio } from '@grandvisionhq/common';
import { useLink } from '@grandvisionhq/frk-routing';
import { getProductKeyFromCTType } from '@grandvisionhq/utils';

const VariantPickerVariant = ({ variant , labels , activeVariantSku , onPick  })=>{
    const queryString = typeof window !== 'undefined' ? window.location.search : '';
    const { sku , imageUrl , slug , description , productType  } = variant;
    const accessibleName = description || `${sku} - ${labels.screenreaderDefault}`;
    const variantLink = useLink({
        route: 'products.detail',
        params: {
            slug,
            sku,
            key: getProductKeyFromCTType(productType)
        }
    });
    const href = `${variantLink === null || variantLink === void 0 ? void 0 : variantLink.href}${queryString}`;
    return /*#__PURE__*/ React__default.createElement(SelectionBoxRadio, {
        // Only enable tab stop on the active variant
        // Arrow keys can be used to move between the different radio buttons
        tabIndex: activeVariantSku === sku ? 0 : -1,
        "aria-labelledby": "variants-label",
        checked: activeVariantSku === sku ? true : false,
        title: accessibleName,
        name: "variant",
        className: classnames('variant-picker__variant', {
            'variant-picker__variant--active': activeVariantSku === sku
        }),
        onChange: ()=>onPick(variant, href)
    }, /*#__PURE__*/ React__default.createElement("a", {
        href: href,
        "data-t": "variant-picker-button",
        // user will tab-stop on the radio buttons of the SelectionBoxRadio
        tabIndex: -1,
        onClick: (event)=>onPick(variant, href, event)
    }, /*#__PURE__*/ React__default.createElement("img", {
        src: `${imageUrl}?q=70&w=62&h=36&fit=fill&fm=jpeg`,
        alt: accessibleName
    })));
};

export { VariantPickerVariant };
//# sourceMappingURL=VariantPickerVariant.js.map
